import React from "react";
import { Modal, Text, TouchableOpacity, View } from "react-native";
import { AppColors } from "../../utility/AppColors";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { CommonButton } from "../../common/CommonButton";

const StopStreamingPopup = ({
  stopStreaming,
  setStopStreaming,
  onConfirm,
  disabled,
}) => {
  const deviceSize = useDeviceSize();
  return (
    <Modal
      visible={stopStreaming}
      transparent={true}
      animationType="fade"
      onRequestClose={() => setStopStreaming(false)}
    >
      <View
        style={{
          flex: 1,
          backgroundColor: AppColors.blackTrans_000000a8,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <TouchableOpacity
          style={{ position: "absolute", width: "100%", height: "100%" }}
          onPress={() => setStopStreaming(false)}
        />
        <View
          style={[
            {
              width:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "90%"
                  : "35%",
            },
          ]}
        >
          <View
            style={{
              padding: 24,
              borderRadius: 24,
              backgroundColor: AppColors.black_121212,
              gap:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? 10
                  : 20,
            }}
          >
            <Text
              style={[
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? AppFontStyle.SEMIBOLD_ANYBODY_12
                  : AppFontStyle.SEMIBOLD_ANYBODY_18,
                {},
              ]}
            >
              Are you sure you want to stop streaming?
            </Text>
            <Text
              style={[
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? AppFontStyle.REGULAR_ANYBODY_12
                  : AppFontStyle.REGULAR_ANYBODY_16,
                {},
              ]}
            >
              Stopping your stream will end the live session for all viewers.
              Any ongoing interactions, chats, or audience engagement will be
              interrupted. If you plan to restart, you may need to reinitialize
              your stream settings.
            </Text>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <CommonButton
                title="No"
                onTap={() => setStopStreaming(false)}
                buttonStyle={{
                  paddingVertical: 10,
                  paddingHorizontal: 14,
                  backgroundColor: AppColors.white,
                  borderRadius: 8,
                  shadowOpacity: 0,
                  borderWidth: 2,
                  borderColor: AppColors.white,
                }}
                fontStyle={[
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? AppFontStyle.SEMIBOLD_ANYBODY_12
                    : AppFontStyle.SEMIBOLD_ANYBODY_16,
                  { color: AppColors.gray_414651 },
                ]}
                image={false}
              />
              <CommonButton
                title={disabled ? "Stopping..." : "Yes"}
                onTap={onConfirm}
                disabled={disabled}
                buttonStyle={{
                  paddingVertical: 10,
                  paddingHorizontal: 14,
                  backgroundColor: disabled
                    ? AppColors.gray_414651
                    : AppColors.appViolentColor_6D08C3,
                  borderRadius: 8,
                  shadowOpacity: 0,
                  borderWidth: 2,
                  borderColor: disabled
                    ? AppColors.gray_414651
                    : AppColors.appViolentColor_6D08C3,
                }}
                fontStyle={
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? AppFontStyle.SEMIBOLD_ANYBODY_12
                    : AppFontStyle.SEMIBOLD_ANYBODY_16
                }
                image={false}
              />
            </View>
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default StopStreamingPopup;

const useStyles = CreateResponsiveStyle({}, {});
